//@flow
import Grid from '@mui/material/Grid2';
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React, { useMemo } from 'react';
import { useTranslation } from "react-i18next";
import House2Icon from "../../../assets/images/icons/general/house2Icon";
import MapPinIcon from "../../../assets/images/icons/general/mapPinIcon";
import { EXHIBITOR_PROFILE } from "../../../locales/components/namespaces";
import type { Exhibition, Exhibitor } from "../../../types/exhibition/types";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import CalendarViewDayIcon from '@mui/icons-material/CalendarViewDay';
import { FormControl, FormHelperText } from "@mui/material";
import { ErrorMessage } from "formik";

type Props = {
	exhibitor: Exhibitor,
	exhibition: Exhibition
}

const CatalogHeader = (props: Props) => {
	const { exhibitor, exhibition, formik, disabled, inputVariant } = props
	const { t } = useTranslation(EXHIBITOR_PROFILE)
	const items = [
		{
			icon: MapPinIcon,
			key: t('Hall'),
			value: exhibitor.room,
		},
		{
			icon: House2Icon,
			key: t('Stand Number'),
			value: exhibitor.kiosk,
		},
	]
	const kioskSignDisabled = useMemo(() => (disabled || !exhibition.isKioskSignEditable || exhibitor.isKioskSignReadOnly), [disabled, exhibition.isKioskSignEditable, exhibitor.isKioskSignReadOnly])
	return (
		<Box>
			<Grid
				container
				sx={{
					display: 'flex',
					flexDirection: 'row',
					gap: '2.25rem'
				}}
			>
				{items.map((i) => {
					const { icon: Icon } = i
					return (
						<Box key={i.key}>
							<Grid
								container
								sx={{
									display: 'flex',
									flexDirection: 'column',
									alignItems: 'flex-start'
								}}
							>
								<Grid size={12}>
									<Stack direction="row" spacing="0.75rem">
										<Icon/>
										<Typography
											sx={{
												fontSize: '1.125rem',
												lineHeight: '1.5rem',
												color: '#5E666B'
											}}
										>
											{i.key + ':'}
										</Typography>
									</Stack>
								</Grid>
								<Grid size={12}>
									<Typography
										sx={{
											fontSize: '1.5rem',
											lineHeight: '2rem',
											color: '#5E666B',
											fontWeight: 700,
											ml: 4
										}}
									>
										{i.value}
									</Typography>
								</Grid>
							</Grid>
						</Box>
					);
				})}
			</Grid>
		</Box>
	)
}

export default CatalogHeader;